import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApi } from 'model/Api';
import { Partner } from 'model/Partner';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import OperationTrigger from 'component/part/OperationTrigger';
import H2 from 'component/part/H2';

const initialPartner: Partner = {
  id: 0,
  name: '',
  unitSalary: 0,
};

const style = {
  form: {
    ...generalStyle.form,
    ['& input']: {
      maxWidth: '32rem',
    },
  },
};

const PartnerEdit: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const partnerId = parseInt(urlParams.id || '');
  const [partner, setPartner] = useState<Partner>(initialPartner);

  const onChangePartner = <T extends keyof Partner>(key: T, value: Partner[T]) => {
    setPartner({ ...partner, [key]: value });
  };

  const onSubmit = async () =>
    !!(await api.partner.update(partner));

  useEffect(() => {
    (async () => {
      if (partnerId) {
        const partnerResponse = await api.partner.get(partnerId);
        if (partnerResponse) {
          setPartner(partnerResponse);
        } else {
          setPartner({ ...partner, id: partnerId });
        }
      }
    })();
  }, [partnerId]);

  return <Layout>
    <BackLink link='/partner/list' label='協力業者一覧'></BackLink>
    <H2>{partnerId ? '協力業者編集' : '協力業者登録'}</H2>
    <div css={style.form}>
      <FormContent label='協力業者名'>
        <input type="text" value={partner.name} onChange={(e) => onChangePartner('name', e.target.value)} />
      </FormContent>
      <FormContent label='日給'>
        <input type="number" value={partner.unitSalary} onChange={(e) => onChangePartner('unitSalary',  parseInt(e.target.value))} />
      </FormContent>
      <OperationTrigger
        onSubmit={onSubmit}
        onOk={() => navigate('/partner/list')}
        buttonText={partnerId ? '更新' : '登録'}
        confirmText={partnerId ? '協力業者情報を更新します' : '協力業者を登録します'}
        submitText={partnerId ? '更新' : '登録'}
        doneText={`${partnerId ? '更新' : '登録'}が完了しました`}
        errorText={`${partnerId ? '更新' : '登録'}に失敗しました`}
      />
    </div>
  </Layout>;
};

export default PartnerEdit;
